<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row>
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-select
          v-model="classType"
          clearable
          filterable
          class="w-200px ml-10px"
          placeholder="解析实体"
          size="small"
        >
          <el-option
            v-for="item in classTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          v-model="taskName"
          clearable
          class="w-200px ml-10px"
          placeholder="任务名称"
          size="small"
        ></el-input>
        <el-input
          v-model="modelName"
          clearable
          class="w-200px ml-10px"
          placeholder="模型名称"
          size="small"
        ></el-input>
        <el-select
          v-model="status"
          clearable
          filterable
          class="w-200px ml-10px mr-10px"
          placeholder="状态"
          size="small"
        >
          <el-option label="进行中" :value="0"></el-option>
          <el-option label="已完成" :value="1"></el-option>
          <el-option label="失败" :value="2"></el-option>
        </el-select>
        <el-button type="primary" @click="searchTableData">{{ $t('search') }}</el-button>
        <el-button type="danger" :disabled="!$hasAccess('delete')" @click="delTask(idList)">{{
          $t('delete')
        }}</el-button>
      </el-row>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        border
        class="mt-20px"
        height="calc(100% - 104px)"
        :highlight-current-row="true"
        @selection-change="selectionChange"
        stripe
        ref="table"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column
          prop="modelParsingTaskName"
          label="任务名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="modelName" label="模型名称" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="standardName"
          label="参照标准"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="className" label="解析实体" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="classAttributeName"
          label="解析属性"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="runStatusName" label="状态" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="解析结果" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="createdTime"
          label="创建时间"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="delTask([scope.row.id])"
              :disabled="!$hasAccess('delete')"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-20px float-right">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page.pageNo"
          :page-sizes="$pageSizeAll"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import stdClassListService from '@/services/stdClassListService'
import ModelParsingTaskService from '@/services/ModelParsingTaskService'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'ModelParseProgress',
  components: { selectStandardId },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      classType: '',
      classTypeList: [],
      taskName: '',
      modelName: '',
      status: '',
      tableLoading: false,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      idList: [],
    }
  },
  watch: {
    standardId(newVal) {
      if (newVal) {
        this.getClassTypeList()
        this.searchTableData()
      }
    },
    classType() {
      this.searchTableData()
    },
    status() {
      this.searchTableData()
    },
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
    },
    // 获取实体列表
    async getClassTypeList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classTypeList = res.data
      }
    },
    async searchTableData() {
      this.tableLoading = true
      const res = await ModelParsingTaskService.getModelParseProgress({
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        standardId: this.standardId,
        classId: this.classType,
        TaskName: this.taskName,
        ModelName: this.modelName,
        runStatus: this.status,
      })
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        this.page.total = res.totalCount
      } else {
        this.tableData = []
        this.page.total = 0
      }
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.searchTableData()
    },
    handleCurrentChange(pageNo) {
      this.page.pageNo = pageNo
      this.searchTableData()
    },
    selectionChange(val) {
      this.idList = _.map(val, (item) => {
        return item.id
      })
    },
    delTask(ids) {
      if (ids.length > 0) {
        this.$confirm('是否确定要删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const res = await ModelParsingTaskService.deleteRunRecord(ids)
          if (res) {
            this.$message.success('删除成功')
            this.searchTableData()
          }
        })
      } else {
        this.$message.info('请选择要删除的数据')
      }
    },
  },
  created() {
    this.getClassTypeList()
    this.searchTableData()
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
}
</script>
